<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import Card from "../../shared/Card.svelte";
  import { ArticleType, DatabaseName } from "../../stores/types";
  import type { Article } from "../../stores/types";

  export let item: Article, itemId: string;

  let databaseNameArticle = DatabaseName.ARTICLES.toString();
  let entryPromise = null;
  let logPromise = null;
  let sauerteig: boolean = false;
  if (item.type === ArticleType.SAUERTEIG.toString()) {
    sauerteig = true;
  }

  // delete item
  const handleDelete = () => {
    if (confirm("really delete this item?:   " + item.name)) {
      var logItem = {
        action: "delete",
        changedItem: item,
      };
      logPromise = $userbaseStore.insertItem({
        databaseName: "logs",
        item: logItem,
      });
      entryPromise = $userbaseStore.deleteItem({
        databaseName: databaseNameArticle,
        itemId,
      });
    }
  };
</script>

<Card>
  <div class="ingredient" title={itemId}>
    <div class="header">
      <h3>{item.name}</h3>
      <span class="tag" class:sauerteig>{item.type}</span>
      <div class="delete-item" title="Delete item">
        <span class="icon-button"
          ><i class="fas fa-trash-alt" on:click={() => handleDelete()} /></span
        >
      </div>
    </div>
  </div>
</Card>

<style>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  h3 {
    margin: 10 auto;
    color: rgb(109, 55, 33);
  }
  .icon-button {
    font-size: medium;
    color: dimgrey;
    margin-right: 10px;
    cursor: pointer;
  }
  .tag {
    border-radius: 6px;
    padding: 10px;
    background-color: lightsalmon;
  }
  .sauerteig {
    background-color: lightgrey;
  }
</style>
